var _defs, _circle, _line, _line2, _line3, _line4, _line5, _line6, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarship(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss-core",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c2410c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fb923c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss-member",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9a3412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f97316"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 104,
    r: 62,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 104,
    x2: 100,
    y2: 42,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 104,
    x2: 154,
    y2: 73,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 104,
    x2: 154,
    y2: 135,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 104,
    x2: 100,
    y2: 166,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 104,
    x2: 46,
    y2: 135,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 104,
    x2: 46,
    y2: 73,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 42,
    r: 10,
    fill: "url(#ss-member)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 73,
    r: 10,
    fill: "url(#ss-member)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 135,
    r: 10,
    fill: "url(#ss-member)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 166,
    r: 10,
    fill: "url(#ss-member)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 135,
    r: 10,
    fill: "url(#ss-member)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 73,
    r: 10,
    fill: "url(#ss-member)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 104,
    r: 22,
    fill: "url(#ss-core)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 104,
    r: 22,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 92 L108 112 L100 106 L92 112 Z",
    fill: "#1a0f0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarship);
export default __webpack_public_path__ + "static/media/starship.fb1fcf655a4b2f3656863b99e739a74a.svg";
export { ForwardRef as ReactComponent };